module.exports = __webpack_public_path__ + "static/media/Plane_taking_off.585007b0.mp3";